import { defineMessages } from 'react-intl';

export const errorMessages = defineMessages({
    inputIsRequired: {
        defaultMessage: 'Field is required.',
    },
    invalidEmail: {
        defaultMessage: 'Please input a valid email address.',
    },
    duplicateItem: {
        defaultMessage: 'The item already exists.',
    },
    invalidPhoneNumber: {
        defaultMessage: 'Please input a valid phone number.',
    },
    invalidEmailOrPhone: {
        defaultMessage: 'Please input a valid email or phone number.',
    },
});
